import angular from 'angular'
import template from './template.html'

export class NominaTimbresGenerarxmlComponent {
  autorizando
  confirmando

  constructor() {
    this.autorizando = false
    this.confirmando = false
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data.filter((item) => {
        return item.pendiente === false
          && item.status_pagado === true
          && item.status_timbrado === false
        // && item.xml_generado === false;
      })

      this.data.length
    }
  }

  actualizar (data) {
    this.autorizando = false
    this.confirmando = false

    if (!data)
      return

    this.onChange({
      $event: {
        data: data,
      },
    })
  }
}

angular.module('nominas.nomina')
  .component('nominaTimbresGenerarxml', {
    template: template,
    controller: NominaTimbresGenerarxmlComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      data: '<',
      onChange: '&',
    },
  })


// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/generarxml/component.js